import { render, staticRenderFns } from "./ReviewGroupTournament.vue?vue&type=template&id=b3d98b12&scoped=true"
import script from "./ReviewGroupTournament.vue?vue&type=script&lang=js"
export * from "./ReviewGroupTournament.vue?vue&type=script&lang=js"
import style0 from "./ReviewGroupTournament.vue?vue&type=style&index=0&id=b3d98b12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d98b12",
  null
  
)

export default component.exports